// addBannerApi
import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from '../../config/axiosInstance'

// ---------------------fatch-category-listing--------------------------
export const fetchConsultantListApi = async (data) => {
  const endPoint = `/admin/consultant`
  return await axios.post(endPoint, data, setJwtToken())
}

// ---------------------fatch-online -offline--------------------------
export const fetchOnlineOfflineApi = async (data) => {
  const endPoint = `/admin/consultant/online_offline`
  return await axios.post(endPoint, data, setJwtToken())
}
// Fetching Deleted Consultant List API
export const getDeletedConsultantListApi = async (data) => {
  const endPoint =
    `/admin/consultant/delete/list` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Approve consultant status

export const approveConsultantStatus = async (data) => {
  const endPoint = `/admin/consultant/approve`
  return await axios.put(endPoint, data, setJwtToken())
}

export const moveConsultantToBinApi = async (data) => {
  const endPoint = `/admin/consultant/move_to_bin`
  return await axios.put(endPoint, data, setJwtToken())
}

export const restoreConsultantFromBinApi = async (data) => {
  const endPoint = `/admin/consultant/restore_from_bin`
  return await axios.put(endPoint, data, setJwtToken())
}

// Change consultant status

export const changeConsultantStatus = async (data) => {
  const endPoint = `/admin/consultant/block_unblock`
  return await axios.put(endPoint, data, setJwtToken())
}


// Change consultant status

export const changeConsultantStatusisFake = async (data) => {
  const endPoint = `/admin/consultant/toggle_fakeness`
  return await axios.put(endPoint, data, setJwtToken())
}

// add consultant

export const addConsultant = async (data) => {
  // console.log(data,"data-->controller")
  const endPoint = `/admin/consultant/add`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

// Edit Consultant
export const editConsultant = async (data) => {
  const endPoint = `/admin/consultant/update`
  return await axios.put(endPoint, data, setMultiPartHeader())
}

// Edit Consultant V1
export const editConsultantV1 = async (data) => {
  const endPoint = `/admin/consultant/update/v1`
  return await axios.put(endPoint, data, setMultiPartHeader())
}

// Get selected consultant detail

export const getSelectedConsultantDetail = async (data) => {
  const endPoint =
    `/admin/consultant/details` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Get selected consultant detail V1
export const getSelectedConsultantDetailV1 = async (data) => {
  const endPoint =
    `/admin/consultant/details/v1` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// // ---------------------add-Banner---------------------------
// export const addBannerApi = async (data) => {
//   const endPoint = '/admin/banner/add'
//   return await axios.post(endPoint, data, setMultiPartHeader())
// }

// // ---------------------update-banner---------------------------
// export const updateBannerApi = async (data) => {
//   const endPoint = `/admin/banner/edit`
//   return await axios.put(endPoint, data, setMultiPartHeader())
// }
// // ---------------------change-status-banner---------------------------
export const fetchConsultantRequestCountApi = async () => {
  const endPoint = `/admin/consultant/counts`
  return await axios.get(endPoint, setJwtToken())
}

export const sendWarningApi = async (data) => {
  const endPoint = `/admin/consultant/send_warning`
  return await axios.post(endPoint, data, setJwtToken())
}

// Consultant Management Order History
export const getConsultantOrderHistoryApi = async (data) => {
  const endPoint =
    `/admin/consultant/order_history` +
    // `https://49a5-122-161-53-242.ngrok-free.app`+
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}


//consultant waitlist 
export const getConsultantWaitlist = async (data) => {
  const endPoint =
    `/admin/consultant/waitlist` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const getConsDashboardAnalyticsApi = async (data, axiosConfig = {}) => {
  const endPoint =
    `/admin/consultant/numerical-analytics` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, { ...setJwtToken(), ...axiosConfig });
};

export const getConsultantOnlineTimeApi = async (consultantId, params = {}, axiosConfig = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  const endPoint = `/admin/consultant/${consultantId}/online-time${query ? `?${query}` : ""}`;
  return await axios.get(endPoint, { ...setJwtToken(), ...axiosConfig });
};

export const getConsultantOnlineTimeSummaryApi = async (consultantIds = [], axiosConfig = {}) => {
  const ids = Array.isArray(consultantIds) ? consultantIds.join(",") : String(consultantIds || "");
  const endPoint =
    `/admin/consultant/online-time/today-summary` +
    "?" +
    new URLSearchParams({ consultantIds: ids }).toString();
  return await axios.get(endPoint, { ...setJwtToken(), ...axiosConfig });
};
//remove from consultant waitlist
export const removeConsultantWaitlist = async (data) => {
  const endPoint =
    `/admin/consultant/remove_from_waitlist` +
    // `https://49a5-122-161-53-242.ngrok-free.app`+
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.delete(endPoint, setJwtToken())
}
// -----------order history for chat --------------

export const Chathistory = async (data) => {
  const endPoint = `/admin/consultant/order/history?listFor=cons`;

  try {
      const response = await axios.get(endPoint, { params: data }); // Corrected here
      return response;
  } catch (error) {
      console.error("Error in Chathistory:", error.response?.data || error.message);
      throw error; // Re-throw error for higher-level handling
  }
};

// // ---------------send remedy---------------------



// export const fetchAOCList = async () => {
//   const endPoint = `/admin/consultant/remedy?type=AREAOFCONCERN`;

//   try {
//       const response = await axios.get(endPoint); // Corrected here
//       return response;
//   } catch (error) {
//       console.error("Error in Chathistory:", error.response?.data || error.message);
//       throw error; // Re-throw error for higher-level handling
//   }
// };



// // ---------------------change-status-banner---------------------------
export const fetchWalletDeductionApi = async (data) => {
  const endPoint = `/admin/consultant/wallet/deduction`
  return await axios.post(endPoint, data, setJwtToken())
}

export const fetchWalletAdditionApi = async (data) => {
  const endPoint = `/admin/consultant/wallet/addition`
  return await axios.post(endPoint, data, setJwtToken())
}

// Consultant Management Availability Rate
export const consultantCheckPerformanceAvailability = async (data) => {
  const endPoint =
    `/admin/consultant/availibility/rate` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Consultant Management Loyal Customer
export const consultantCheckPerformanceLoyalCustomer = async (data) => {
  const endPoint =
    `/admin/consultant/loyal/customer` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Consultant Management Avg Talk Time
export const consultantCheckPerformanceAvgTalkTime = async (data) => {
  const endPoint =
    `/admin/consultant/avg/talk/time` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Consultant Management Avg  Time
export const consultantCheckPerformanceAvgTime = async (data) => {
  const endPoint = `/admin/consultant/avg/rating`
  return await axios.post(endPoint, data, setJwtToken())
}

// Consultant Management Total Chat
export const consultantCheckPerformanceTotalChat = async (data) => {
  const endPoint = `/admin/consultant/chat/total`+
  '?' +
  new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Mark Green Tick In Consultant API
export const markGreenTickApi = async (data) => {
  const endPoint = `/admin/consultant/mark_green_tick`
  return await axios.put(endPoint, data, setMultiPartHeader())
}
// Go Live In Consultant API
export const goLiveApi = async (data) => {
  const endPoint = `/admin/consultant/go_live`
  return await axios.put(endPoint, data, setJwtToken())
}

// New customer conversion
export const newCustomerConversionApi = async (data) => {
  const endPoint =
    `/admin/consultant/new/customer/conversion` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// 1st → 2nd completed call with the same consultant (repeat conversion)
export const sameConsultantRepeatConversionApi = async (data) => {
  const endPoint =
    `/admin/consultant/same/consultant/repeat/conversion` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Customer satisfaction
export const customerSatisfactionApi = async (data) => {
  const endPoint =
    `/admin/consultant/customer/satisfaction` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// New customer rating percentage
export const newCustomerRatingPercentageApi = async (data) => {
  const endPoint =
    `/admin/consultant/new/customer/rating` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

//New user serve properly percentage.
export const newUserServeProperlyPercentageApi = async (data) => {
  const endPoint =
    `/admin/consultant/new/user/serve/properly` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Customer retention.
export const customerRetentionApi = async (data) => {
  const endPoint =
    `/admin/consultant/customer/retention` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// New User Retention.
export const newUserRetentionApi = async (data) => {
  const endPoint =
    `/admin/consultant/user/retention` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Logout consultant from all device

export const logoutConsultantFromAllDevice = async (data) => {
  const endPoint =
    `/admin/consultant/log_out` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Update consultant high priority status
export const updateHighPriorityStatusApi = async (data) => {
  const endPoint = `/admin/consultant/high_priority`
  return await axios.put(endPoint, data, setJwtToken())
}

// Update consultant can end the call status
export const updateCanEndTheCallStatusApi = async (data) => {
  const endPoint = `/admin/consultant/can_end_the_call`
  return await axios.put(endPoint, data, setJwtToken())
}

// Refund consultation on behalf of consultant
export const refundConsultationApi = async (data) => {
  const endPoint = `/admin/consultant/refund/consultation`
  return await axios.post(endPoint, data, setJwtToken())
}

// Get consultant transaction history
export const getConsultantTransactionHistoryApi = async (data) => {
  const endPoint =
    `/admin/consultant/transactions` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Get consultant bank details
export const getConsultantBankDetailsApi = async (consultantId) => {
  const endPoint = `/admin/request/get-by-consultant-id/${consultantId}`
  return await axios.get(endPoint, setJwtToken())
}

// Add consultant bank details
export const addConsultantBankDetailsApi = async (data) => {
  const endPoint = `/admin/request/add`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

// Get all tags
export const fetchAllTagsApi = async () => {
  const endPoint = `/admin/consultant/tags`
  return await axios.get(endPoint, setJwtToken())
}

// Create new tag
export const createTagApi = async (data) => {
  const endPoint = `/admin/consultant/tags`
  return await axios.post(endPoint, data, setJwtToken())
}

// Set tags on consultant
// Expected data format: { consultantId: "id", tags: ["tagId1", "tagId2", ...] }
export const setConsultantTagsApi = async (data) => {
  const endPoint = `/admin/consultant/set_tags`
  // Ensure data has consultantId and tags array
  if (!data.consultantId) {
    throw new Error("consultantId is required");
  }
  if (!Array.isArray(data.tags)) {
    data.tags = [];
  }
  return await axios.put(endPoint, data, setJwtToken())
}

// Set group on consultant
export const setConsultantGroupApi = async (data) => {
  const endPoint = `/admin/consultant/set_group`
  return await axios.put(endPoint, data, setJwtToken())
}

export const setConsultantSubGroupApi = async (data) => {
  const endPoint = `/admin/consultant/set_sub_group`
  return await axios.put(endPoint, data, setJwtToken())
}

// Update tag
export const updateTagApi = async (data) => {
  const endPoint = `/admin/consultant/tags/update`
  return await axios.put(endPoint, data, setJwtToken())
}

// Delete tag
export const deleteTagApi = async (tagId) => {
  const endPoint = `/admin/consultant/tags/${tagId}`
  return await axios.delete(endPoint, setJwtToken())
}

// Add review by admin
export const addReviewByAdminApi = async (data) => {
  const endPoint = `/admin/consultant/add-review`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

// Get consultant reviews
export const getConsultantReviewsApi = async (data) => {
  const endPoint =
    `/admin/consultant/reviews` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Update review by admin
export const updateReviewByAdminApi = async (data) => {
  const endPoint = `/admin/consultant/update-review`
  return await axios.put(endPoint, data, setMultiPartHeader())
}

// Toggle review status (show/hide)
export const toggleReviewStatusApi = async (data) => {
  const endPoint = `/admin/consultant/toggle-review-status`
  return await axios.put(endPoint, data, setJwtToken())
}

// Delete review permanently
export const deleteReviewApi = async (data) => {
  const endPoint = `/admin/consultant/delete-review?reviewId=${data.reviewId}`
  return await axios.delete(endPoint, setJwtToken())
}

// Get consultant KPI data
export const getConsultantKPIApi = async (data) => {
  const endPoint =
    `/admin/consultant/kpi` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// Get consultant KPI detail
export const getConsultantKPIDetailApi = async (data) => {
  const endPoint =
    `/admin/consultant/kpi/detail` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const fetchPreSelectedConsultantApi = async (data) => {
  const endPoint =
    `/admin/pre-selected-consultant` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const addPreSelectedConsultantApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/add`
  return await axios.post(endPoint, data, setJwtToken())
}

export const uploadPreSelectedConsultantSheetApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/bulk-upload`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

export const updatePreSelectedConsultantApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/update`
  return await axios.put(endPoint, data, setJwtToken())
}

export const deletePreSelectedConsultantApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/delete`
  return await axios.delete(endPoint, { ...setJwtToken(), data })
}

export const updatePreSelectedConsultantInterviewStatusApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/interview_status`
  return await axios.put(endPoint, data, setJwtToken())
}

export const updatePreSelectedConsultantInterviewDetailsApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/interview-details`
  return await axios.put(endPoint, data, setJwtToken())
}

export const reschedulePreSelectedConsultantInterviewMailApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/reschedule-interview-mail`
  return await axios.put(endPoint, data, setJwtToken())
}

export const fetchPreSelectedConsultantEmailTemplatesApi = async () => {
  const endPoint = `/admin/pre-selected-consultant/email-templates`
  return await axios.get(endPoint, setJwtToken())
}

export const updatePreSelectedConsultantEmailTemplateApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/email-template`
  return await axios.put(endPoint, data, setJwtToken())
}

export const sendPreSelectedConsultantPersonalizedEmailApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/personalized-email`
  return await axios.post(endPoint, data, setJwtToken())
}

export const sendPreSelectedConsultantSubmittedCommunicationApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-forms/communication`
  return await axios.post(endPoint, data, setJwtToken())
}

export const sendPreSelectedConsultantCorrectionMailApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-form/correction-mail`
  return await axios.post(endPoint, data, setJwtToken())
}

export const fetchPreSelectedConsultantSubmittedFormsApi = async (data) => {
  const endPoint =
    `/admin/pre-selected-consultant/submitted-forms` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const updatePreSelectedConsultantAssetReviewApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-form/asset-review`
  return await axios.put(endPoint, data, setJwtToken())
}

export const updatePreSelectedConsultantStage3Api = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-form/stage3`
  return await axios.put(endPoint, data, setMultiPartHeader())
}

export const updatePreSelectedConsultantSubmittedConsultantDataApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-form/consultant-data`
  return await axios.put(endPoint, data, setMultiPartHeader())
}

export const updatePreSelectedConsultantSubmittedOnboardingRowApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-form/onboarding-row`
  return await axios.put(endPoint, data, setJwtToken())
}

export const submitManualPreSelectedConsultantOnboardingApi = async (data) => {
  const endPoint = `/admin/pre-selected-consultant/submitted-form/manual-onboarding`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

export const getSelectedConsultantFormApi = async (token) => {
  const endPoint = `/pre-selected-consultant-form/${token}`
  return await axios.get(endPoint)
}

export const submitSelectedConsultantFormApi = async (token, data) => {
  const endPoint = `/pre-selected-consultant-form/${token}`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

export const getConsultantOnlineScheduleApi = async (data) => {
  const endPoint =
    `/admin/consultant/online-schedule` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const saveConsultantOnlineScheduleApi = async (data) => {
  const endPoint = `/admin/consultant/online-schedule`
  return await axios.put(endPoint, data, setJwtToken())
}

export const fetchAstrologerRegistrationFormApi = async (data) => {
  const endPoint =
    `/admin/astrologer-registration-form` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const updateAstrologerRegistrationFormStatusApi = async (data) => {
  const endPoint = `/admin/astrologer-registration-form/selection-status`
  return await axios.put(endPoint, data, setJwtToken())
}
